import axios from "axios";


const BASE_URL = process.env.NODE_ENV === "production"
    // ? "http://72.60.102.151:5000"  // Update to your production API URL
    // ? "https://entropyconnect.com"
    ? "https://backend.entropyconnect.com"
    : "http://localhost:5000";

const API = axios.create({
    baseURL: `${BASE_URL}/api`
});

export const UPLOADS_BASE_URL = `${BASE_URL}/uploads`;


// ======================================
// TOKEN
// ======================================

API.interceptors.request.use(

    (config) => {

        const token =
            localStorage.getItem("token");

        if (token) {

            config.headers.Authorization =
                `Bearer ${token}`;
        }

        return config;
    }
);


export default API;